/**
 * Check cookie names from NWX to determine the correct weavebillpay.com endpoint to use.
 * Note, these checks only apply to production for now. (Dev doesn't have the cookies). Skipping preview links, as well, as those are soon to change
 * when with the PCI org migration.
 *
 * Actionable redirects:
 * - staging.getweave.com -> staging.weavebillpay.com
 * - edge.getweave.com -> edge.weavebillpay.com
 */

import { buildProductionInvoiceUrl } from '../utils/build-production-invoice-url';
import { getSiteNameFromCookie } from '../utils/get-site-name-from-cookie';

export const getPaySiteInvoiceUrl = (invoiceResponseUrl: string | undefined) => {
  // Implement the hook logic here
  const isProduction = import.meta.env.MODE === 'production';

  if (isProduction) {
    return buildProductionInvoiceUrl(invoiceResponseUrl, getSiteNameFromCookie());
  }

  /**
   * Not modifying non-production URLs
   */
  return invoiceResponseUrl;
};
